import * as z from "zod/v4";
import { onboardingV2AnalyticsProductIdSchema } from "./analytics-product-id";

export const unarchiveOnboardingV2Product = {
  name: "unarchiveOnboardingV2Product" as const,
  input: z.object({
    teamId: z.string().min(1),
    productId: onboardingV2AnalyticsProductIdSchema,
  }),
  output: z.object({ success: z.boolean() }),
};

export type UnarchiveOnboardingV2ProductInput = z.infer<
  typeof unarchiveOnboardingV2Product.input
>;
export type UnarchiveOnboardingV2ProductOutput = z.infer<
  typeof unarchiveOnboardingV2Product.output
>;
